import apiModel from './base/api.js'
export default {
  apiModel
}